import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PartyService } from 'src/app/services/api/party/party.service';
import { Party } from 'src/app/models/party-manager/party';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
export enum ComponentStateEnum {
  none = 'none',
  loading = 'loading',
  nodata = 'nodata',
  ready = 'ready',
}
@Component({
  selector: 'app-ctoport-res-spec-table',
  templateUrl: './ctoport-res-spec-table.component.html',
  styleUrls: ['./ctoport-res-spec-table.component.scss']
})
export class CTOPortResSpecTableComponent extends SpecTableComponent implements OnInit {
  isps: Party[];
  
   componentState: BehaviorSubject<ComponentStateEnum> = new BehaviorSubject<ComponentStateEnum>(ComponentStateEnum.none);
 constructor(
    private partyService: PartyService,
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

    ngOnInit() {
      this.isps = [];
      this.componentState.next(ComponentStateEnum.none);
      this.partyService.getCustomers().subscribe((data) => {
        for (const party of data) {
          this.isps.push(party);
        }
        this.componentState.next(ComponentStateEnum.ready);
      });
      this.displayedColumns = ['name', 'state', 'CTOPort-position', 'usedBy', 'searchKey'];

      super.onInit();

      
     
    }

}
